import { DescriptiveLinkGroupData } from 'design-system/shared/models/app-data-model';
import DescriptiveLinkCard from '../descriptive-link-card/DescriptiveLinkCard';
import './DescriptiveLinkGroup.scss';

import React from 'react';

export type DescriptiveLinkGroupProps = {
  descriptiveLinkGroup: DescriptiveLinkGroupData;
}

const DescriptiveLinkGroup: React.FC<DescriptiveLinkGroupProps> = ({ descriptiveLinkGroup}: DescriptiveLinkGroupProps) => {
  const linkCards = descriptiveLinkGroup.descriptive_link_card.map((card, index) => {
    return <DescriptiveLinkCard descriptiveLinkCard={card} key={index} />
  });

  return <div className='descriptive-link-group'>{linkCards}</div>
};

export default DescriptiveLinkGroup;
